import { useEffect, useState } from 'react';

import { Alert, Box, Card, CardContent, Stack } from '@mui/material';
import {
  Bold,
  Text,
  Title,
  Tracker,
} from '@zippeditoolsjs/dashboards';

import ChipGroup from './ChipGroup';
import Icon from './Icon';

const handleIconNameDefault = (tracker) => {
  const colorIconMap = {
    emerald: 'checkmark-circle',
    rose: 'close-circle',
    yellow: 'alert-circle',
    gray: 'help-circle',
    '': 'help-circle',
    undefined: 'help-circle',
  };
  return colorIconMap[tracker?.color];
};

export default function TrackerCard(props) {
  const {
    sx,
    isLoading,
    filterVariant = 'chip',
    timeFrame,
    setTimeFrame,
    title = 'Cycles',
    leftText = 'Trackers',
    rightTest = 'Proyects with trackers',
    subtitle = 'Analysis of the behavior of the cycles',
    trackerData,
    handleIconName = handleIconNameDefault,
    noDataText = 'No data',
  } = props;

  const [trackers, setTrackers] = useState([]);

  useEffect(() => {
    window.addEventListener('error', (e) => {
      if (e.message === 'ResizeObserver loop limit exceeded') {
        const resizeObserverErrDiv = document.getElementById(
          'webpack-dev-server-client-overlay-div'
        );
        const resizeObserverErr = document.getElementById(
          'webpack-dev-server-client-overlay'
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute('style', 'display: none');
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute('style', 'display: none');
        }
      }
    });
  }, []);

  useEffect(() => {
    const trackerLength = trackerData?.length;
    if (trackerLength) {
      const minTrack = 30;
      let newTrackers = [...trackerData];
      if (trackerLength < minTrack) {
        for (let i = 0; i < minTrack - trackerLength; i++) {
          const voidTrack = { color: '', tooltip: '' };
          if (i < (minTrack - trackerLength - 1) / 2) {
            newTrackers = [voidTrack, ...newTrackers];
          } else {
            newTrackers.push(voidTrack);
          }
        }
      }
      setTrackers(newTrackers);
    }
  }, [trackerData]);

  // Real data exists only if at least one tracker has a styled color.
  const hasData = trackerData?.some((tracker) => tracker.color);

  return (
    <Card sx={{ mt: 1, ...sx }}>
      <CardContent>
        <Stack spacing={2}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Icon
              iconName={handleIconName(trackerData?.[0])}
              color={trackerData?.[0].color || 'slate'}
              tooltip={trackerData?.[0].tooltip || 'No data'}
            />
            <Title>{title}</Title>
            <Text className="text-center">{subtitle}</Text>
          </Box>

          {filterVariant === 'chip' ? (
            <ChipGroup
              disabled={isLoading}
              timeFrame={timeFrame}
              setTimeFrame={setTimeFrame}
              optionTimes={[
                { label: '1 hours', deltaTime: 1 },
                { label: '3 hours', deltaTime: 3 },
                { label: '6 hours', deltaTime: 6 },
                { label: '12 hours', deltaTime: 12 },
                { label: '1 day', deltaTime: 24 },
              ]}
              color="info"
              size="small"
            />
          ) : null}
          {hasData ? (
            <>
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Box justifyContent="start" className="space-x-2">
                  <Text>
                    <Bold>{leftText}</Bold>
                  </Text>
                </Box>
                <Text>{rightTest}</Text>
              </Box>
              <Tracker data={trackers} className="mt-0" />
            </>
          ) : (
            <Alert severity="info">{noDataText}</Alert>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
}
